module.exports = __webpack_public_path__ + "img/chrome.6cf26d09.svg";